import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToReportDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from '../../../api/apiClient';
import Location from "../../commoncomponents/location";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

function IButtonReportTable(props) {

  let assetCustomerName = props.assetCustomerName;
  let timeZone = props.timeZone ? props.timeZone.toString().slice(25, 55) : '';
  const data = (
    <Table striped responsive>
    <thead>
      <tr className="nowwrapTH">
        <th>ID</th>
        <th>Created</th>
        <th>Event</th>
        <th>Asset</th>
        <th>Location</th>       
        <th>Customer</th>
        <th>Device ID</th>
        <th>Asset ID</th>
        <th>Log ID</th>
      </tr>
    </thead>
    <tbody>
      {props.iButtonData.map((element) => {
        return (
			<tr key={element.id || `${element.serialno}-${element.created}`}>
				<td>{element.id}</td>
				<td>{utcToReportDate(element.created)}</td>
				<td>{element.event}</td>
				<td>
					<a
						href={`/Rpt-LocationData?assetId=${element.assetId}&assetName=${element.asset}`}
						target="_blank"
						rel="noreferrer"
					>
						{element.asset}
					</a>
					<br />
					<ShowIButtonName
						ibuttonId={element.ibuttonId}
						serialno={element.serialno}
						iButtonName={element.iButtonName}
					/>
				</td>
				<td>
					<Location
						address={`${element.location}`}
						lat={element.latitude}
						lng={element.longitude}
					/>
				</td>
				<td>{element.customer}</td>
				<td>{element.deviceId}</td>
				<td>{element.assetId}</td>
				<td>{element.logId}</td>
			</tr>
		);
      })}
    </tbody>
  </Table>
);
const handleDownloadExcel = () => {
    downloadCSVFile(props.iButtonData, "IButtonMonthlyReport", assetCustomerName, timeZone);
  }
  return (
    <ToggleBar
      caption="iButton Events"
      icon="fa fa-address-card-o"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default IButtonReportTable;
